module.exports = __webpack_public_path__ + "img/92153.f430c275.svg";